import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getFormErrors } from 'http-client/apiClient';
import { useLoginMutation } from 'http-client/hooks/authHooks';
import { ApiResponse, LoginDto, LoginResponseDto } from 'http-client/types/auth.types';

// Meta title

const SaaSLogin: React.FC = () => {
  const navigate = useNavigate();
  const { mutate: login, isPending, error } = useLoginMutation();
  const [twoFactorRequired, setTwoFactorRequired] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      emailOrPhone: '',
      password: '',
    } as LoginDto,
    validationSchema: Yup.object({
      emailOrPhone: Yup.string().required('Please Enter valid email or phone number'),
      password: Yup.string().required('Please Enter Your Password'),
    }),
    onSubmit: (values) => {
      login(values, {
        onSuccess: (response: ApiResponse<LoginResponseDto>) => {
          if (response?.data?.requiresTwoFactor) {
            setTwoFactorRequired(true);
            navigate('/two-factor-verification', { state: { email: values.emailOrPhone } });
          } else {
            navigate('/dashboard');
          }
        },
        onError: () => {
          setTwoFactorRequired(false);
        },
      });
    },
  });

  useEffect(() => {
    const fetchCats = async () => {
      try {
        const response = await fetch('/cats'); // Adjust endpoint if needed
        if (!response.ok) throw new Error('Failed to fetch cats');
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error('Error fetching cats:', error);
      }
    };

    fetchCats();
  }, []);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back (SaaS)!</h5>
                        <p>Sign in to continue to Pharmacy Management.</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error && (
                        <Alert color="danger">{getFormErrors(error) || 'Login failed'}</Alert>
                      )}
                      {twoFactorRequired && (
                        <Alert color="info">OTPs have been sent to your email and phone.</Alert>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Email Or Phone Number</Label>
                        <Input
                          name="emailOrPhone"
                          className="form-control"
                          placeholder="Enter email or phone number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailOrPhone}
                          invalid={
                            validation.touched.emailOrPhone && !!validation.errors.emailOrPhone
                          }
                        />
                        {validation.touched.emailOrPhone && validation.errors.emailOrPhone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.emailOrPhone}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={validation.touched.password && !!validation.errors.password}
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      {/* <div className="form-check">
                        <Input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <Label className="form-check-label" htmlFor="customControlInline">
                          Remember me
                        </Label>
                      </div> */}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={isPending}
                        >
                          {isPending ? 'Logging in...' : 'Log In'}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Reset your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                {/* <p>
                  Don&apos;t have an account?{' '}
                  <Link to="/register" className="fw-medium text-primary">
                    Signup now
                  </Link>
                </p> */}
                <p>
                  © {new Date().getFullYear()} Pharmacy Management. Crafted with{' '}
                  <i className="mdi mdi-heart text-danger" /> by Your Team
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SaaSLogin;
